const corporatePlannerCards = [
  {
    image: "/Assets/themed-decorations-and-setups.webp",
    title: "Themed Decorations and Setups",
    price: 4999,
    rating: 4
  },
  {
    image: "/Assets/employee-engagment-events.webp",
    title: "Team Building Activities",
    price: 4999,
    rating: 4
  },
  {
    image: "/Assets/company-anniverseries.webp",
    title: "Company Anniversary",
    price: 4999,
    rating: 4
  },
  {
    image: "/Assets/office-openings.webp",
    title: "Office Openings",
    price: 4999,
    rating: 4
  },
  {
    image: "/Assets/photobooth-setups.webp",
    title: "Photobooth Setups",
    price: 4999,
    rating: 4
  },
  {
    image: "/Assets/exhibition-booth-design.webp",
    title: "Exhibition Booth Design & Services",
    price: 4999,
    rating: 4
  },
  {
    image: "/Assets/corporate-recognition-and-award-ceremony-events.webp",
    title: "Recognition & Award Ceremony",
    price: 4999,
    rating: 4
  },
  {
    image: "/Assets/corporate-professional-photography-and-videography.webp",
    title: "Photography & Videography",
    price: 4999,
    rating: 4
  },
  {
    image: "/Assets/showroom-inauguration.webp",
    title: "Showroom Inauguration",
    price: 4999,
    rating: 4
  },
  {
    image: "/Assets/stage-lights-sounds-and-DJ.webp",
    title: "Stage, Lights, Sounds, and DJ",
    price: 4999,
    rating: 4
  },
  {
    image: "/Assets/virtual-reality-games.webp",
    title: "Virtual Reality Games",
    price: 4999,
    rating: 4
  },
  {
    image: "/Assets/product-launches.webp",
    title: "Product Launches",
    price: 4999,
    rating: 4
  }
];

export default corporatePlannerCards;
